var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mt-6" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "level mt-3" }, [
      _c("div", { staticClass: "level-left" }, [
        _c("div", { staticClass: "level-item" }, [
          _vm.item && _vm.item.portalLogo
            ? _c("img", {
                staticStyle: { "max-height": "80px", "max-width": "240px" },
                attrs: { src: _vm.item.portalLogo, alt: "Portal-Logo" },
              })
            : _c("span", { staticClass: "has-text-grey" }, [
                _vm._v("Kein Logo — es wird das Standard-Logo verwendet."),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "level-left" }, [
        _c("input", {
          ref: "file",
          staticStyle: { display: "none" },
          attrs: { type: "file", accept: "image/*" },
          on: {
            change: function ($event) {
              return _vm.onFileChange($event.target.files)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary level-item",
            class: { "is-loading": _vm.isUploading },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$refs.file.click()
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("photo")]),
            _vm._v(" Logo hochladen\n            "),
          ]
        ),
        _vm._v(" "),
        _vm.item && _vm.item.portalLogo
          ? _c(
              "button",
              {
                staticClass: "button level-item",
                attrs: { disabled: _vm.isUploading },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.removeLogo.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Entfernen")]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "help" }, [
      _vm._v(
        "Wird im Kopf des Kundenportals für die Portal-Zugänge dieses Kunden angezeigt. Ohne Logo wird das Standard-Logo verwendet."
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "redesign-table" }, [
      _c("div", { staticClass: "table-wrapper" }, [
        _c("div", { staticClass: "row is-header level mb-0" }, [
          _c("div", { staticClass: "level-left" }, [
            _c("h2", { staticClass: "level-item" }, [_vm._v("Portal-Logo")]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }